import useChartDateFormatter from '@Dashboard/RiskUser/useChartDateFormatter';
import { TimeRangeEnum } from '@Dashboard/TimeRangeSelector';
import { useUtcOffsetStore } from '@Models/useUtcOffsetModel';
import { useMemo } from 'react';
import { ECharts, EChartsProps } from 'src/ECharts';
import {
  dashboardTimerangeXData,
  dashboarRiskUserLineSeries,
} from 'src/ECharts/utils';

export interface TopRiskUserProps extends EChartsProps {
  data: Record<string, Record<string, number>>;
  interval: string;
}

export const TopRiskUser = (props: TopRiskUserProps) => {
  const { data: _data, interval, ...echartsProps } = props;
  const timeModel = useUtcOffsetStore();
  const { format } = useChartDateFormatter();

  const data = useMemo(() => _data ?? {}, [_data]);

  const series = useMemo(() => {
    // Sort top users by total
    const users = Object.entries(data)
      .map(
        ([user, timerange]) =>
          // Count total for each user
          [
            user,
            Object.values(timerange).reduce(
              (prevCount, count) => prevCount + count,
              0
            ),
          ] as [string, number]
      )
      .sort((a, b) => b[1] - a[1]) // Sort users by total in descending order
      .map(([user]) => user);
    return users.map((user, index) =>
      dashboarRiskUserLineSeries({
        data,
        user,
        index,
      })
    );
  }, [data]);

  return (
    <ECharts
      series={series}
      xAxis={{
        data: dashboardTimerangeXData(
          data[Object.keys(data)[0]],
          timeModel.offset
        ).map((timestamp) =>
          format({
            timestamp,
            interval: interval as TimeRangeEnum,
          })
        ),
        axisLabel: {
          rotate: 0,
        },
      }}
      grid={{ top: 20, right: 300, bottom: 40, left: 40 }}
      legend={{
        top: 'middle',
        orient: 'vertical',
        align: 'left',
        right: 0,
        textStyle: { overflow: 'truncate', width: 225, align: 'left' },
      }}
      height="220px"
      {...echartsProps}
    />
  );
};
